export default "__VITE_ASSET__DgqBLHz0__"